import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import AuthShell from "@/components/AuthShell";
import api, { formatApiErrorDetail } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { useI18n } from "@/i18n";
import { GoogleButton, Field } from "./Login";

export default function Signup() {
  const { t } = useI18n();
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);
  const { setUser } = useAuth();
  const navigate = useNavigate();

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    setError("");
    try {
      const { data } = await api.post("/auth/register", { name, email, password });
      setUser(data);
      navigate("/app");
    } catch (err) {
      setError(formatApiErrorDetail(err.response?.data?.detail));
    } finally {
      setBusy(false);
    }
  };

  return (
    <AuthShell title={t("Create your account")} sub={t("Free to create. Subscribe when you are ready.")}>
      <form onSubmit={submit} className="space-y-4" data-testid="signup-form">
        <Field id="name" label={t("Your name")} type="text" value={name} onChange={(e) => setName(e.target.value)} testid="signup-name" placeholder="Asha Nair" autoComplete="name" />
        <Field id="email" label={t("Email")} type="email" value={email} onChange={(e) => setEmail(e.target.value)} testid="signup-email" placeholder="you@example.com" autoComplete="email" />
        <Field id="password" label={t("Password")} type="password" value={password} onChange={(e) => setPassword(e.target.value)} testid="signup-password" placeholder={t("At least 8 characters")} autoComplete="new-password" />
        {error && <p className="rounded-lg bg-bad/10 px-3 py-2 text-sm text-bad" data-testid="signup-error">{error}</p>}
        <button
          type="submit"
          disabled={busy}
          data-testid="signup-submit"
          className="w-full rounded-xl bg-accent px-4 py-3 text-sm font-bold text-white transition-transform hover:-translate-y-0.5 disabled:opacity-60"
        >
          {busy ? t("Creating account…") : t("Create account")}
        </button>
      </form>
      <div className="my-5 flex items-center gap-3 text-xs text-muted">
        <span className="h-px flex-1 bg-line" /> {t("or")} <span className="h-px flex-1 bg-line" />
      </div>
      <GoogleButton />
      <p className="mt-6 text-sm text-muted">
        {t("Already have an account?")} <Link to="/login" className="font-bold text-accent" data-testid="signup-login-link">{t("Log in")}</Link>
      </p>
      <p className="mt-3 text-xs text-muted">
        {t("By signing up you agree to our")} <Link to="/legal/terms" className="underline">{t("Terms")}</Link> {t("and")}{" "}
        <Link to="/legal/privacy" className="underline">{t("Privacy policy")}</Link>.
      </p>
    </AuthShell>
  );
}
